<template>
  <div>
    <!-- ---------- -->
    <div class="footer_warp">
      <div class="footer_cont">
        <!-- 上部 -->
        <div class="footer_cont_l">
          <!--上部 左 -->
          <div class="footer_cont_l_div">
            <div class="footer_cont_l_div_item">
              <p class="footer_cont_l_title">慧云心境</p>
              <ul class="footer_cont_l_ul">
                <li
                    v-for="(item, index) in arrList"
                    :key="index"
                    @click="toPages(item.url, item.id)"
                >
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="footer_cont_l_div_item">
              <p class="footer_cont_l_title">产品中心</p>
              <ul class="footer_cont_l_ul">
                <li
                    v-for="(item, index) in arrList2"
                    :key="index"
                    @click="toPages(item.url)"
                >
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="footer_cont_l_div_item">
              <p class="footer_cont_l_title">商务合作</p>
              <ul class="footer_cont_l_ul">
                <li
                    v-for="(item, index) in arrList3"
                    :key="index"
                    @click="toNews(item.url)"
                >
                  {{ item.title }}
                </li>
              </ul>
            </div>
            <div class="footer_cont_l_div_item2">
              <p class="footer_cont_l_title">服务支持</p>
              <ul class="footer_cont_l_ul">
                <router-link to="support">
                  <li>服务支持</li>
                </router-link>
                <router-link to="registry">
                  <li>服务注册</li>
                </router-link>
              </ul>
            </div>
          </div>
        </div>
        <!-- top 中 -->
        <div class="footer_cont_c">
          <div class="phone_item">
            <div class="phone_div">
              <img class="phone_img" src="../assets/img/home/home_phone.png"/>
            </div>
            <div class="phone_item_text">
              <p>13850002860</p>
            </div>
          </div>

          <div class="email_item">
            <div class="email_div">
              <img class="email_img" src="../assets/img/home/home_email.png"/>
            </div>
            <div class="email_item_text">
              <p>sales@huiyunpico.com</p>
            </div>
          </div>
          <div class="address_item">
            <div class="address_div">
              <img class="address_img" src="../assets/img/home/home_address.png"/>
            </div>
            <div class="address_item_text">
              <p>厦门市湖里区高新技术员安岭二路35号奥佳华集团9楼</p>
            </div>
          </div>
          <div class="mark_item">
            <img class="mark_wx" src="../assets/img/home/home_weixin.png">&nbsp;
            <img class="mark_qq" src="../assets/img/home/home_qq.png">&nbsp;
            <!--            <img class="mark_wb" src="../assets/img/home/home_weibo.png">&nbsp;-->
            <!--            <img class="mark_space" src="../assets/img/home/home_qq_space.png">&nbsp;-->
          </div>
        </div>
        <div class="footer_line">
        </div>
        <!-- top 右 -->
        <div class="footer_cont_r">
          <div class="footer_cont_r_border">
            <img src="../assets/img/home/home_logo.png"/>
          </div>
        </div>
      </div>
      <!-- 下部 -->
      <div class="footer_warp_btm">
        <p>Copyright 2023 HuiYunBaiKe.All Right Reserved&nbsp;
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer noopener">
            闽ICP备2023014932号-1
          </a>
        </p>
      </div>
    </div>
    <!-- --------- -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      arrList: [
        {
          title: "公司介绍",
          url: "/introduction",
          //id: "introduction",
        },
        {
          title: "联系我们",
          url: "/contact",
          //id: "contact",
        }
      ],
      arrList2: [
        {
          title: "心理压力评测训练系统",
          url: "/products",
        },
        {
          title: "心理压力情绪疏导系统",
          url: "/products",
        },
        {
          title: "智能VR心理疏导系统",
          url: "/products",
        },
        {
          title: "智能减压按摩椅",
          url: "/products",
        },
        {
          title: "智能减压按摩产品",
          url: "/products",
        }
      ],
      arrList3: [
        {
          title: "商务合作",
          url: "/cooperation",
        }
      ],
    };
  },
  mounted() {
    let _this = this;
    _this.$nextTick(function () {
      window.addEventListener("scroll", _this.handleScroll);
    });
  },
  methods: {
    // 锚点跳转
    toGuid(path, id) {
      localStorage.setItem("toId", id);
      this.$router.push(path);
      //查找存储的锚点id
      let Id = localStorage.getItem("toId");
      let toElement = document.getElementById(Id);
      //锚点存在跳转
      if (Id) {
        toElement.scrollIntoView();
        localStorage.setItem("toId", "");
      }
    },
    toPages(url) {
      this.$router.push(url);
    },
    toNews(url) {
      this.$router.push(url);
    }
  }
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
body,
h1,
h2,
h3,
h4,
h5,
h6,
div,
p,
dl,
dt,
dd,
ol,
ul,
li,
form,
table,
th,
td,
a,
img,
span,
strong,
var,
em,
input,
textarea,
select,
option {
  margin: 0;
  padding: 0;
}

/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.footer_warp {
  width: 100vw;
  height: 388px;
  background: #FFFFFF;
}

.footer_cont {
  width: 1500px;
  margin: 0 auto;
  margin-right: 90px;
  display: flex;
}

.footer_cont_l {
  font-size: 16px;
  font-weight: 500;
  color: #dddddd;
  line-height: 22px;
  padding-top: 77px;
}

.footer_cont_l_title {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #6F9ED3;
  line-height: 22px;
  width: 64px;
}

.footer_cont_l_ul {
  margin-top: 36px;
}

.footer_cont_l_ul li {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #626262;
  margin-top: 10px;
  cursor: pointer;
}

.footer_cont_l_div {
  display: flex;
}

.footer_cont_l_div_item {
  margin-right: 72px;
}

.footer_cont_c {
  margin-top: 77px;
  margin-left: 80px;
  width: 380px;
}

.address {
  width: 467px;
  font-size: 16px;
  font-family: "PingFangSC-Regular", "PingFang SC";
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  margin-top: 42px;
}

.footer_cont_r {
  margin-top: 90px;
  margin-left: 70px;
}

.footer_cont_r p {
  text-align: center;
  font-size: 14px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  color: #ffffff;
  line-height: 20px;
  margin-top: 17px;
}

.footer_cont_r_border {
  width: 130px;
  height: 109px;
  /*border: 1px solid #979797;*/
}

.footer_cont_r_border img {
  width: 125px;
  height: 101px;
  margin: 7px 8px;
}

.footer_warp_btm {
  width: 1280px;
  margin: 0 auto;
  height: 65px;
  /*margin-top: 56px;*/
  /*border-top: 1px solid #444444;*/
}

.footer_warp_btm p {
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  color: #626262;
  line-height: 48px;
}

.footer_warp_btm p a {
  /*text-align: center;*/
  font-size: 12px;
  font-weight: 500;
  color: #626262;
  /*line-height: 48px;*/
}

.footer_warp_btm p a:hover {
  /*text-align: center;*/
  font-size: 12px;
  font-weight: 500;
  color: #6F9ED3;
  /*line-height: 48px;*/
}

.phone_item {
  /*width: 420px;*/
  /*height: 340px;*/
  /*margin-top: 45px;*/
}

.phone_item_text {
  margin-left: 30px;
  background: #ffffff;
}

.phone_item_text p {
  /*margin-top: 72px;*/
  /*margin-left: 86px;*/
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #626262;
  line-height: 22px;
}

.email_item {
  /*width: 420px;*/
  /*height: 340px;*/
  margin-top: 10px;
}

.email_item_text {
  margin-left: 30px;
  background: #ffffff;
}

.email_item_text p {
  /*margin-top: 72px;*/
  /*margin-left: 86px;*/
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #626262;
  line-height: 22px;
}

.address_item {
  /*width: 420px;*/
  /*height: 340px;*/
  margin-top: 10px;
}

.address_item_text {
  margin-left: 30px;
  background: #ffffff;
}

.address_item_text p {
  /*margin-top: 72px;*/
  /*margin-left: 86px;*/
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #626262;
  line-height: 22px;
}

.mark_item {
  margin-top: 10px;
}

.phone_div {
  height: 10px;
  width: 10px;
  float: left;
  position: relative;
}

.phone_img {
  height: 100%;
  width: 100%;
  padding-top: 5px;
  position: absolute;
}

.email_div {
  height: 10px;
  width: 10px;
  float: left;
  position: relative;
}

.email_img {
  height: 10px;
  width: 10px;
  padding-top: 5px;
  position: absolute;
}

.address_div {
  height: 10px;
  width: 10px;
  float: left;
  position: relative;
}

.address_img {
  height: 10px;
  width: 10px;
  padding-top: 5px;
  position: absolute;
}

.mark_wx {
  height: 24px;
  width: 24px;
}

.mark_qq {
  height: 24px;
  width: 24px;
}

.mark_wb {
  height: 24px;
  width: 24px;
}

.mark_space {
  height: 24px;
  width: 24px;
}

.footer_line {
  margin-top: 79px;
  margin-left: 50px;
  border: 1px solid #D4D4D4;
  opacity: 1;
  border-radius: 0px 0px 0px 0px;
  height: 151px;
  width: 0px;
}
</style>
